import React, { Suspense } from 'react';
import ErrorBoundary from './error-boundary';

interface IErrorHandlerProps {
    children?: any;
    fallback?: JSX.Element;
    renderAfterPromise?: Promise<any>;  // 如果提供promise，会等promise结束之后才会渲染children
}

interface IErrorHandlerState {
    showChildren: boolean;
}

export default class LazyBoundary extends React.Component<IErrorHandlerProps, IErrorHandlerState> {
    public constructor(props) {
        super(props);
        let showChildren = true;
        if (props.renderAfterPromise) {
            showChildren = false;
            props.renderAfterPromise.then(() => { // promise执行完之后渲染children
                this.setState({ showChildren: true });
            });
        }
        this.state = {
            showChildren,
        };
    }

    public render() {
        const { children, fallback = <div></div> } = this.props;
        if (!this.state.showChildren) return null;
        return <ErrorBoundary>
            <Suspense fallback={fallback}>
                {children}
            </Suspense>
        </ErrorBoundary>;
    }
}
